import { isAuthenticated } from 'mk/bazaar/common/userUtils';
import { CommentCreateForm, CommentFormData } from 'mk2/apps/forum/components/CommentCreateEditForm';
import styles from 'mk2/apps/forum/containers/PostDetail/PostDetail.mscss';
import { PostEntity } from 'mk2/apps/forum/schemas';
import { UserEntity } from 'mk2/schemas';
import React from 'react';

interface OwnProps {
    anonymousMode: boolean;
    canAdd: boolean;
    hasBlueToolbar?: boolean;
    initialValues: CommentFormData;
    currentValues: CommentFormData;
    isAskAnExpert: boolean;
    isBlogsComment: boolean;
    isContest: boolean;
    isEdit: boolean;
    isGroupsComment: boolean;
    isIOS: boolean;
    isMobile: boolean;
    post: PostEntity;
    requestUser: UserEntity;
    requestUserPermissions: string[];
    showContestAnswers: boolean;
    textareaRef?: (r: HTMLTextAreaElement) => void;
    onSave(values: CommentFormData);
    onAddCommentUnauthenticated();
}

const ForumCommentAdd: React.FunctionComponent<OwnProps> = ({
    anonymousMode,
    canAdd,
    currentValues,
    hasBlueToolbar,
    initialValues,
    isAskAnExpert,
    isBlogsComment,
    isContest,
    isEdit,
    isGroupsComment,
    isIOS,
    isMobile,
    onAddCommentUnauthenticated,
    onSave,
    post,
    requestUser,
    requestUserPermissions,
    showContestAnswers,
    textareaRef,
}) => {

    const showFakeForm = (
        !isAuthenticated(requestUser) &&
        !isAskAnExpert &&
        (!isContest || (isContest && !showContestAnswers)) &&
        !post?.deletedAt &&
        !post?.topic.deletedAt
    );

    const form = (
        <CommentCreateForm
            anonymousMode={anonymousMode}
            hasBlueToolbar={hasBlueToolbar}
            isEdit={isEdit}
            isMobile={isMobile}
            isIOS={isIOS}
            textareaRef={textareaRef}
            isContest={isContest}
            isBlogsComment={isBlogsComment}
            isGroupsComment={isGroupsComment}
            requestUserPermissions={requestUserPermissions}
            initialValues={initialValues}
            currentValues={currentValues}
            onSave={onSave}
        />
    );

    if (canAdd) {
        return form;
    } else if (showFakeForm) {
        return (
            <div
                className={styles.ForumCommentAdd__fakeTextArea}
                onClick={onAddCommentUnauthenticated}
            >
                {form}
            </div>
        );
    } else {
        return null;
    }
};

ForumCommentAdd.displayName = 'ForumCommentAdd';

export default React.memo<OwnProps>(ForumCommentAdd);
